import { useEffect, useState } from "react";
import API from "../../../services/API";
import {message, Table} from "antd";
import { mainColumns, nestedColumns } from "./FirebaseDeviceEventsTableColumns";
import usePageState from "../../../helpers/usePageState";

export default function FirebaseDeviceEvents({userId}) {
  const [deviceEvents, setDeviceEvents] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = usePageState("device-events-rows", ["0"]);
  const [loading, setLoading] = useState(false);

  const successMessage = (content, duration = 5) => {
    message.success(content, duration);
  };

  const errorMessage = (content, duration = 10) => {
    message.error(content, duration);
  };

  const handleExpand = (expanded, record) => {
    if (expanded) {
      setExpandedRowKeys([record.key]);
    } else {
      setExpandedRowKeys([]);
    }
  };

  const expandedRowRender = (row) => {
    return (
        <Table columns={nestedColumns} dataSource={[row]} pagination={false} />
    );
  };

  const fetchDeviceEvents = async () => {
    try {
      setLoading(true);
      let response = await API.getFirebaseDeviceEvents(userId);
      const eventsWithKey = response.firebaseDeviceEvents.map((event, index) => ({
        ...event,
        key: index,
      }));
      setDeviceEvents(eventsWithKey);
    } catch (error) {
      errorMessage("Error fetching device events");
      errorMessage(error?.response?.data?.error_message || error?.response?.data?.errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDeviceEvents();
  }, []);

  return (
      <Table
          columns={mainColumns}
          expandable={{
            expandedRowRender,
            expandedRowKeys,
            onExpandedRowsChange: setExpandedRowKeys,
          }}
          dataSource={deviceEvents}
          loading={loading}
          pagination={false}
      />
  );
}
